@if (jobRequest) {
<div class="dialogContainer">
  <div class="dialogHeader">
    <img
      class="closeButton"
      src="/images/closeIconWithoutBox.png"
      (click)="closeDialog()"
    />
  </div>
  <div class="dialogContent">
      <app-dialog-input-title title="Interval"
                              [required]="true"></app-dialog-input-title>
      <select [(ngModel)]="jobRequest.interval">
          @for (interval of intervals; track interval) {
          <option [ngValue]="interval.value">
              {{ interval.name }}
          </option>
          }
      </select>
      <app-dialog-input-title title="Interval værdi"></app-dialog-input-title>
      <input type="number"
             [ngModel]="jobRequest.intervalValue"
             (ngModelChange)="jobRequest.intervalValue = numberConversion($event)" />
      <app-dialog-input-title title="Oprettet af"
                              [required]="true"></app-dialog-input-title>
      <select [(ngModel)]="jobRequest.createdById">
          <option value="0" class="hidden">Vælg opretter</option>
          @for (user of users; track user.id) {
          <option [ngValue]="user.id">
              {{ user.name }}
          </option>
          }
      </select>
      <app-dialog-input-title title="Ansvarlig"
                              [required]="true"></app-dialog-input-title>
      <select [(ngModel)]="jobRequest.responsibleId">
          <option value="0" class="hidden">Vælg ansvarlig</option>
          @for (user of users; track user.id) {
          <option [ngValue]="user.id">
              {{ user.name }}
          </option>
          }
      </select>
      <app-dialog-input-title title="Status"
                              [required]="true"></app-dialog-input-title>
      <select [(ngModel)]="jobRequest.status">
          @for (status of Statuses; track status) {
          <option [ngValue]="status.value">
              {{ status.name }}
          </option>
          }
      </select>

      @if(jobRequest.status == statusDTO.Completed){
      <app-dialog-input-title title="Udført dato"></app-dialog-input-title>
      <mat-form-field (click)="CompletedDatePicker.open()">
          <mat-label>Vælg dato</mat-label>
          <input matInput
                 [matDatepicker]="CompletedDatePicker"
                 [(ngModel)]="jobRequest.completed"
                 name="NextInvoiceDate"
                 #CompletedDate />
          <mat-datepicker-toggle matSuffix
                                 [for]="CompletedDatePicker"></mat-datepicker-toggle>
          @if (jobRequest.completed) {
          <button matSuffix
                  mat-icon-button
                  (click)="clearDate($event, CompletedDate)">
              <mat-icon>close</mat-icon>
          </button>
          }
      </mat-form-field>
      <mat-datepicker #CompletedDatePicker></mat-datepicker>
      }
      <app-dialog-input-title title="Beskrivelse"></app-dialog-input-title>
      <textarea class="textarea" [(ngModel)]="jobRequest.description"> </textarea>
      <app-dialog-input-title title="Kunde"
                              [required]="true"></app-dialog-input-title>
      <select [ngModel]="jobRequest.clientId"
              (ngModelChange)="clientCascade($event)">
          <option value="0" class="hidden">Vælg Kunde</option>
          @for (client of clients; track client.id) {
          <option [ngValue]="client.id">
              {{ client.name }}
          </option>
          }
      </select>
      @if(jobRequest.clientId > 0 && shownPlants.length > 0){
      <app-dialog-input-title title="Anlæg"></app-dialog-input-title>
      <select [ngModel]="jobRequest.plantId"
              (ngModelChange)="plantCascade($event)">
          <option [ngValue]="null">(Intet Anlæg valgt)</option>
          @for (plant of shownPlants; track plant.id) {
          <option [ngValue]="plant.id">
              {{ plant.plantName }}
          </option>
          }
      </select>

      } @if(jobRequest.plantId!= undefined && jobRequest.plantId > 0 && shownComponents.length > 0){
      <app-dialog-input-title title="Komponent"></app-dialog-input-title>
      <select [(ngModel)]="jobRequest.componentId">
          <option [ngValue]="null" >(Intet Komponent valgt)</option>
          @for (component of shownComponents; track component) {
          <option [ngValue]="component.id">
              {{ component.typeNumber }}
          </option>
          }
      </select>
      }

      <app-dialog-input-title title="Oprettelses tidspunkt"></app-dialog-input-title>
      <mat-form-field (click)="CreatedDatePicker.open()">
          <mat-label>Vælg dato</mat-label>
          <input matInput
                 [matDatepicker]="CreatedDatePicker"
                 [(ngModel)]="jobRequest.created"
                 name="CreatedDate"
                 #CreatedDate />
          <mat-datepicker-toggle matSuffix
                                 [for]="CreatedDatePicker"></mat-datepicker-toggle>
          @if (jobRequest.created) {
          <button matSuffix
                  mat-icon-button
                  (click)="clearDate($event, CreatedDate)">
              <mat-icon>close</mat-icon>
          </button>
          }
      </mat-form-field>
      <mat-datepicker #CreatedDatePicker></mat-datepicker>
  </div>
  <div class="dialogFooter">
    <app-save-button
      [disabled]="
        jobRequest.createdById == 0 ||
        jobRequest.responsibleId == 0 ||
        jobRequest.clientId == 0
      "
      [clickEvent]="saveChanges.bind(this)"
    >
    </app-save-button>
    @if (userService.getSelectedRole == userService.getUserRoleTypes.Admin&&
    jobRequest.id > 0) {
    <app-delete-button [clickEvent]="deleteEntry.bind(this)">
    </app-delete-button>
    }
  </div>
</div>
}
